import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const FileIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 30) / 24}
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.7693 7.6985L16.4616 1.23875C15.6922 0.469741 14.6154 0.00832619 13.3847 0.00832619L4.3077 0.00832619C1.99999 -0.145484 0 1.85397 0 4.16102L0 25.6935C0 28.0005 1.84615 30 4.3077 30H19.6923C22.0001 30 24 28.1544 24 25.6935V10.6208C24 9.54414 23.5385 8.46752 22.7693 7.6985ZM7.38462 12.1589H12C12.6154 12.1589 13.2308 12.6203 13.2308 13.3893C13.2308 14.1582 12.7692 14.6196 12 14.6196H7.38462C6.76923 14.6196 6.15384 14.1582 6.15384 13.3893C6.15384 12.6203 6.76923 12.1589 7.38462 12.1589ZM16.6153 20.7719H7.38462C6.76923 20.7719 6.15384 20.3105 6.15384 19.5414C6.15384 18.7724 6.61539 18.311 7.38462 18.311H16.6153C17.2308 18.311 17.8461 18.7724 17.8461 19.5414C17.8461 20.3105 17.2308 20.7719 16.6153 20.7719Z"
        fill="currentColor"
      />
    </svg>
  )
})

FileIcon.displayName = 'FileIcon'
